
import { prop, Vue } from "vue-class-component";

class Props {
  pickupId = prop<string>({
    required: true
  });

  specialHandling = prop<string[]>({
    default: () => []
  });
}

export default class PickupDetailHeader extends Vue.with(Props) {
  get hasDangerousGoods(): boolean {
    return this.specialHandling.includes("dangerous_goods");
  }

  get hasQuarantine(): boolean {
    return this.specialHandling.includes("quarantine");
  }

  get hasWoodPacking(): boolean {
    return this.specialHandling.includes("wood_packing");
  }

  get hasAnyBadge(): boolean {
    return this.hasDangerousGoods || this.hasQuarantine || this.hasWoodPacking;
  }
}
